import { render, staticRenderFns } from "./TeacherInteraction.vue?vue&type=template&id=7ef00043&scoped=true"
import script from "./TeacherInteraction.vue?vue&type=script&lang=js"
export * from "./TeacherInteraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef00043",
  null
  
)

export default component.exports